import * as type from '../types';

const initialState = {
    filterStation: null,
    filterResourceType: '',
    filterGDDKPeriod: '',
    activeList: [],
    activeLoading: false,
    activeError: false,
    filterHistoryResourceType: '',
    filterHistoryGDDKPeriod: '',
    historyList: [],
    historyLoading: false,
    historyError: false,
    filterConsumptionPeriod: '',
    consumptionList: [],
    consumptionAmount: null,
    consumptionAmountAfterGDDK: null,
    consumptionLoading: false,
    consumptionError: false
}

const gddk = (state = initialState, action) => {
    switch(action.type){
        case type.SET_GDDK_FILTER_STATION:
            return {
                ...state,
                filterStation: action.payload
            }
        case type.SET_GDDK_FILTER_RESOURCE_TYPE:
            return {
                ...state,
                filterResourceType: action.payload
            }
        case type.SET_GDDK_FILTER_GDDK_PERIOD:
            return {
                ...state,
                filterGDDKPeriod: action.payload
            }
        case type.GET_ACTIVE_GDDK_LIST_REQUEST:
            return {
                ...state,
                activeLoading: true,
                activeError: false
            }
        case type.GET_ACTIVE_GDDK_LIST_SUCCEEDED:
            return {
                ...state,
                activeList: action.payload,
                activeLoading: false,
                activeError: false
            }
        case type.GET_ACTIVE_GDDK_LIST_FAILED:
            return {
                ...state,
                activeLoading: false,
                activeError: true
            }
        case type.SET_HISTORY_GDDK_FILTER_RESOURCE_TYPE:
            return {
                ...state,
                filterHistoryResourceType: action.payload
            }
        case type.SET_HISTORY_GDDK_FILTER_GDDK_PERIOD:
            return {
                ...state,
                filterHistoryGDDKPeriod: action.payload
            }
        case type.GET_GDDK_HISTORY_LIST_REQUEST:
            return {
                ...state,
                historyLoading: true,
                historyError: false
            }
        case type.GET_GDDK_HISTORY_LIST_SUCCEEDED:
            return {
                ...state,
                historyList: action.payload,
                historyLoading: false,
                historyError: false
            }
        case type.GET_GDDK_HISTORY_LIST_FAILED:
            return {
                ...state,
                historyLoading: false,
                historyError: true
            }
        case type.SET_GDDK_FILTER_CONSUMPTION_PERIOD:
            return {
                ...state,
                filterConsumptionPeriod: action.payload
            }
        case type.GET_GDDK_CONSUMPTION_LIST_REQUEST:
            return {
                ...state,
                consumptionLoading: true,
                consumptionError: false
            }
        case type.GET_GDDK_CONSUMPTION_LIST_SUCCEEDED:
            return {
                ...state,
                consumptionList: action.payload.consumptionDataList,
                consumptionAmount: action.payload.consumptionAmount,
                consumptionAmountAfterGDDK: action.payload.consumptionAmountAfterGddk,
                consumptionLoading: false,
                consumptionError: false
            }
        case type.GET_GDDK_CONSUMPTION_LIST_FAILED:
            return {
                ...state,
                consumptionLoading: false,
                consumptionError: true
            }
        default:
            return state;
    }
}

export default gddk;